var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loading",style:({'height': _vm.height ? `${_vm.height}px` : '100%', 'width': _vm.width ? `${_vm.width}px` : '100%', 'opacity': _vm.opacity ? `${_vm.opacity}` : '1'})},[_c('div',{staticClass:"fingerprint"})])
}
var staticRenderFns = []

export { render, staticRenderFns }